"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _kebabCase2 = _interopRequireDefault(require("lodash/kebabCase"));

var _classnames = _interopRequireDefault(require("classnames"));

function getToggleWrapperClassName(name, prefix, props, hasValue, classes) {
  var _extends2;

  var className = props.className,
      placement = props.placement,
      appearance = props.appearance,
      cleanable = props.cleanable,
      block = props.block,
      disabled = props.disabled,
      countable = props.countable;
  return (0, _classnames["default"])(className, prefix(name), prefix(appearance), prefix("placement-" + (0, _kebabCase2["default"])(placement)), prefix('toggle-wrapper'), (0, _extends3["default"])((_extends2 = {}, _extends2[prefix('block')] = block, _extends2[prefix('has-value')] = hasValue, _extends2[prefix('disabled')] = disabled, _extends2[prefix('cleanable')] = hasValue && cleanable, _extends2[prefix('countable')] = countable, _extends2), classes));
}

var _default = getToggleWrapperClassName;
exports["default"] = _default;